import axios from "axios";
import API_MAP from "../../services/uri";
import errorHandler from "./errorHandler";

export const fetchTimeline = async ({ page }) => {
	const response = await axios.get(
		`${API_MAP.viewTimeline}?paginate=${page || 20}`
	);
	return response.data.data;
};

export const fetchWeddingPost = async ({ weddingId, paginate }) => {
	const response = await axios.get(
		`${API_MAP.viewAllWeddingPost}?weddingId=${weddingId}&page=1&paginate=${
			paginate || 12
		}`
	);
	return response.data.data;
};

export const reactToWeddingPost = async (credentials) => {
	console.log("the post reaction credential", credentials);
	const response = await axios.post(
		`${API_MAP.reactToWeddingPost}`,
		credentials
	);
	return response.data;
};

export const commentOnWeddingPost = async (credentials) => {
	console.log("the post comment credential", credentials);
	const response = await axios.post(
		`${API_MAP.commentWeddingPost}`,
		credentials
	);
	return response.data;
};

export const getTimelinePostDetails = async ({
	weddingId,
	postId,
	comments_paginate,
}) => {
	const response = await axios.get(`${API_MAP.viewSingleWeddingPost}?
	weddingId=${weddingId}&postId=${postId}&comments_paginate=${
		comments_paginate || 30
	}`);
	return response.data;
};

export const deleteWeddingPostComment = async (postId) => {
	console.log("the post id", postId);
	const response = await axios.delete(
		`${API_MAP.deletePostComment}/${postId}`
	);
	return response.data;
};

export const sprayTimelinePost = async (credentials) => {
	console.log("the spray credential", credentials);
	const response = await axios.post(
		`${API_MAP.sprayTimelinePost}`,
		credentials
	);
	return response.data;
};

export const postToWeddingTimeline = async (credentials) => {
	try {
		const response = await axios.post(
			`${API_MAP.createWeddingPost}`,
			credentials
		);
		return response.data;
	} catch (error) {
		console.log(
			"=====>Post wedding timeline error response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};
